import { render, staticRenderFns } from "./SavedSearchDialog.vue?vue&type=template&id=09527c44"
import script from "./SavedSearchDialog.vue?vue&type=script&lang=js"
export * from "./SavedSearchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports